<template>

    <v-modal :title="`Segment ${count}`">
        <template #body>
            <v-alert :message="error" />
            <v-form-group dir="ver" label="Segment Name">
                <v-input placeholder="My Segment Name" :model="params.segment_name" @input="params.segment_name = $event" />
            </v-form-group>
            <v-form-group dir="ver" label="Tag Name">
                <v-input placeholder="My Tag Name" :model="params.tag_name" @input="params.tag_name = $event" />
                <v-caption>Customers will be tagged and a segment will be created from the tag.</v-caption>
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="segmentCustomers">Segment Customers</v-button>
        </template>
    </v-modal>

</template>

<script>

import ProjectApi from '@api/ProjectApi'

export default {

    props: {
        ids: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
            params: {
                ids: [],
                tag_name: '',
                segment_name: '',
            },
        }
    },

    computed: {

        count() {
            return this.ids.length === 1 ? '1 Customer' : this.ids.length + ' Customers';
        }

    },

    methods: {

        segmentCustomers() {
            this.loading = true;
            this.params.ids = this.ids;
            ProjectApi.segmentCustomers(this.project.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$emit('saved');
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
